var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can(_vm.action,_vm.resourceName))?_c('b-button',{attrs:{"to":{ name: _vm.addRouteName },"variant":"primary"}},[_c('span',{staticClass:"text-nowrap"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }